import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings/hexColors'

export const StructureSearchGroupHeader = styled.div({
  color: hexColors.nightRider,
  fontSize: '1.4rem',
  fontWeight: 700,
  padding: '0.25rem 0 0.5rem 0',
})
